export enum LANGUAGES {
  de = 'de',
  fr = 'fr',
  it = 'it',
  en = 'en',
  es = 'es',
  pt = 'pt',
}
